/**
 * All money in HutDrop is integer cents. Clients only format; they never compute totals.
 */
export function formatCents(cents: number, currency = 'USD', locale = 'en-US'): string {
  if (!Number.isSafeInteger(cents)) throw new RangeError(`Invalid cents value: ${cents}`);
  return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
}

/**
 * Parses what a person types into a price box ("24.99", "$1,299", "5") into cents without
 * floating-point arithmetic. Returns null for anything that isn't a plain non-negative amount.
 */
export function parseMoneyToCents(input: string): number | null {
  const cleaned = input.trim().replace(/[$,\s]/g, '');
  const match = /^(\d{1,9})(?:\.(\d{0,2}))?$/.exec(cleaned);
  if (!match) return null;
  const whole = Number(match[1]);
  const fraction = Number((match[2] ?? '').padEnd(2, '0'));
  return whole * 100 + fraction;
}

/** Cents → editable string ("2499" → "24.99"). */
export function centsToInput(cents: number | null | undefined): string {
  if (cents == null) return '';
  return `${Math.floor(cents / 100)}.${String(cents % 100).padStart(2, '0')}`;
}
